module.exports = __webpack_public_path__ + "static/media/WTP_2020.43226948.png";